var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineBrush(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.25 16c0-1.67 0-3.75 3.75-3.75h4c2.25 0 2.25-.3 2.25-2.25V8c0-1.95 0-2.25-2.25-2.25h-1c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h1c3.5 0 3.75 1.42 3.75 3.75v2c0 2.33-.25 3.75-3.75 3.75h-4c-2.25 0-2.25.61-2.25 2.25 0 .41-.34.75-.75.75s-.75-.34-.75-.75z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 8.75c-.32 0-.61-.21-.71-.51a10.37 10.37 0 0 1 0-6.47c.1-.31.39-.52.71-.52h4c.32 0 .61.21.71.51.7 2.09.7 4.39 0 6.47-.1.31-.38.52-.71.52H8zm3.45-1.5a8.8 8.8 0 0 0 0-4.5H8.56a8.8 8.8 0 0 0 0 4.5h2.89z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 8.75C4.58 8.75 3.25 7.42 3.25 5S4.58 1.25 7 1.25h1c.26 0 .5.13.64.36.14.22.15.5.03.73-.9 1.79-.9 3.54 0 5.33.12.23.1.51-.03.73-.14.22-.38.35-.64.35H7zM4.75 5c0 1.53.64 2.21 2.12 2.25-.5-1.5-.5-3 .01-4.5-1.49.04-2.13.71-2.13 2.25zM12 8.75c-.26 0-.5-.13-.64-.36a.733.733 0 0 1-.03-.73c.89-1.79.89-3.54 0-5.33-.12-.23-.1-.51.03-.73.14-.22.38-.35.64-.35h1c2.42 0 3.75 1.33 3.75 3.75S15.42 8.75 13 8.75h-1zm1.12-1.5c1.49-.04 2.12-.71 2.12-2.25.01-1.54-.63-2.21-2.12-2.25.5 1.5.5 3 0 4.5zM9.5 22.75c-1.03 0-2.25-.39-2.25-2.25v-3c0-1.86 1.22-2.25 2.25-2.25h1c1.03 0 2.25.39 2.25 2.25v3c0 1.86-1.22 2.25-2.25 2.25h-1zm-.75-5.25v3c0 .53 0 .75.75.75h1c.75 0 .75-.22.75-.75v-3c0-.53 0-.75-.75-.75h-1c-.75 0-.75.22-.75.75z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineBrush);
export default __webpack_public_path__ + "static/media/vuesax-outline-brush.a63e34ed2769bafec84bf45ad4625490.svg";
export { ForwardRef as ReactComponent };